export enum ScrollAreaViewportCssVars {
  /**
   * The distance from the horizontal start edge in pixels.
   * @type {number}
   */
  scrollAreaOverflowXStart = '--scroll-area-overflow-x-start',
  /**
   * The distance from the horizontal end edge in pixels.
   * @type {number}
   */
  scrollAreaOverflowXEnd = '--scroll-area-overflow-x-end',
  /**
   * The distance from the vertical start edge in pixels.
   * @type {number}
   */
  scrollAreaOverflowYStart = '--scroll-area-overflow-y-start',
  /**
   * The distance from the vertical end edge in pixels.
   * @type {number}
   */
  scrollAreaOverflowYEnd = '--scroll-area-overflow-y-end',
}
